import './paragraph.scss';
import $ from 'jquery';
import '../../common/js/lazyload/lazyload';
import 'resize-end';
import Cookies from 'js-cookie';

$(window).on('resizeend', () => {
  $('.brandhub-paragraph-col img').lazyLoadXT();
});

$(document).ready(() => {
  $('.brandhub-paragraph-section').each((i, elem) => {
    const sectionElem = $(elem);

    // scroll to anchor links
    sectionElem.find('.brandhub-paragraph-col a[href^="#"]').on('click', (evt) => {
      const btnElem = $(evt.currentTarget);
      const targetAnchor = $(btnElem.attr('href'));
      if (targetAnchor.length !== 0) {
        evt.preventDefault();
        $('html, body').animate({
          scrollTop: targetAnchor.offset().top,
        }, 1000);
      }
    });

    // close btn
    sectionElem.find('a.close-btn').on('click', (evt) => {
      evt.preventDefault();
      sectionElem.slideUp();
    });

    // show only on first visit
    let shownKey = null;
    if (sectionElem.hasClass('show-only-on-first-visit')) {
      shownKey = 'brandhub_paragraph_shown_global';
      if (Cookies.get(shownKey)) {
        sectionElem.css('display', 'none');
      } else {
        sectionElem.css('display', 'block');
        Cookies.set(shownKey, '1', { path: '/', expires: 7 });
      }
    } else if (sectionElem.hasClass('show-only-on-first-visit-page')) {
      shownKey = `brandhub_paragraph_shown_${window.location.pathname.replace(/\//g, ' ').trim().replace(/ /g, '_')}_${i}`;
      if (Cookies.get(shownKey)) {
        sectionElem.css('display', 'none');
      } else {
        sectionElem.css('display', 'block');
        Cookies.set(shownKey, '1', { path: '/', expires: 7 });
      }
    }
  });
});



// WEBPACK FOOTER //
// ./custom_dependencies/brandhub-embxp-frontend/daimler-brandhub-modules/daimler-brandhub-design/daimler-brandhub-design-package/frontend/src/components/paragraph/paragraph.js